import { render, staticRenderFns } from "./TrendyolIntegrationsModal.vue?vue&type=template&id=514a7a60"
import script from "./TrendyolIntegrationsModal.vue?vue&type=script&lang=js"
export * from "./TrendyolIntegrationsModal.vue?vue&type=script&lang=js"
import style0 from "./TrendyolIntegrationsModal.vue?vue&type=style&index=0&id=514a7a60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports